export interface StageTiming {
  name: string;
  durationMs: number;
}

export interface TimingResult {
  totalMs: number;
  stages: StageTiming[];
}

export class StageTimer {
  private readonly startedAt: number;
  private currentName: string | null = null;
  private currentStartedAt: number;
  private finishedAt: number | null = null;
  private readonly stages: StageTiming[] = [];

  constructor(private readonly now: () => number = () => performance.now()) {
    this.startedAt = this.now();
    this.currentStartedAt = this.startedAt;
  }

  enter(name: string): void {
    if (this.finishedAt !== null || name === this.currentName) {
      return;
    }
    const timestamp = this.now();
    this.closeCurrent(timestamp);
    this.currentName = name;
    this.currentStartedAt = timestamp;
  }

  finish(): TimingResult {
    if (this.finishedAt === null) {
      this.finishedAt = this.now();
      this.closeCurrent(this.finishedAt);
    }
    return {
      totalMs: Math.max(0, Math.round(this.finishedAt - this.startedAt)),
      stages: this.stages.map((stage) => ({ ...stage })),
    };
  }

  private closeCurrent(timestamp: number): void {
    if (!this.currentName) {
      return;
    }
    this.stages.push({
      name: this.currentName,
      durationMs: Math.max(0, Math.round(timestamp - this.currentStartedAt)),
    });
  }
}
